import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M16.17 13L12.59 16.59L14 18L20 12L14 6L12.59 7.41L16.17 11H4V13H16.17Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ShortRight"
);
